import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { usePlay } from '../contexts/PlayContext';

function Navbar() {
  const location = useLocation();
  const { user, isAuthenticated, logout } = useAuth();
  // Derived server-side from the days this account actually has plays on,
  // rather than counted locally per browser (D22).
  const { streak } = usePlay();

  // A visitor who has saved something but has no credentials goes to SIGNUP,
  // not login (D42). Signing up attaches credentials to the record they
  // already hold; signing into a different account abandons it silently. For
  // someone with no record there is nothing to lose either way, so login - the
  // likelier intent - stays the default. /signup links back to /login for
  // people who already have an account.
  const isAtRiskGuest = !!user && !isAuthenticated;
  const signInHref = isAtRiskGuest ? '/signup' : '/login';

  const getHelpContext = () => {
    const path = location.pathname;
    if (path === '/') return '?section=favorites';
    if (path === '/all') return '?section=all-games';
    if (path.includes('/edit-score')) return '?section=score-entry';
    return '';
  };

  return (
    <nav className="w-full z-50">
      <div className="w-full pt-1 pb-2">
        <div className="max-w-4xl mx-auto px-2">
          <div className="flex">

            {/* Bulb + wordmark */}
            <Link to="/" className="flex items-start flex-1 min-w-0 pt-1.5">
              <img
                src="/img/light-logo.png"
                alt="Nice Light Games"
                className="w-12 h-14 object-contain"
              />
              <div className="flex flex-col min-w-0">
                <div className="flex gap-2 items-baseline leading-none text-left">
                  <span className="font-display font-bold text-[22px] tracking-[0.09em] uppercase text-nlg-sky">Nice </span>
                  <span className="font-display font-bold text-[22px] tracking-[0.09em] uppercase text-nlg-yellow"> Light</span>
                </div>
                <div className="font-display font-black text-[28px] xs:text-[32px] uppercase leading-tight text-nlg-cream text-left">Games</div>
              </div>
            </Link>

            {/* Icon row + streak, stacked and right-aligned to match the logo's height */}
            <div className="pt-1 flex flex-col items-end gap-1 flex-shrink-0">
              <div className="flex gap-2 items-center">
                {isAuthenticated ? (
                  <button
                    type="button"
                    onClick={logout}
className="flex-shrink-0 transition-opacity duration-150 hover:opacity-80"                    title="Log out"
                  >
                    <img src="/img/logout.png" alt="" className="w-[34px] h-[34px] rounded-full border-2 border-nlg-yellow bg-nlg-yellow" />
                  </button>
                  
                ) : (
                  <Link
                    to={signInHref}
                    className="flex-shrink-0 transition-opacity duration-150 hover:opacity-80"
                    title={isAtRiskGuest ? 'Sign up' : 'Log in'}
                  >
                    <img src="/img/login.png" alt="" className="w-[34px] h-[34px] rounded-full border-2 border-nlg-yellow bg-nlg-yellow" />
                  </Link>
                )}

                <Link
                  to={`/about${getHelpContext()}`}
                  className="flex-shrink-0 transition-opacity duration-150 hover:opacity-80"
                  title="About Nice Light Games"
                >
                  <img src="/img/help.png" alt="" className="w-[34px] h-[34px] rounded-full border-2 border-nlg-yellow bg-nlg-yellow" />
                </Link>
              </div>

              {/* Daily streak - below the icon row. Hidden below 1: "0 day
                  streak" is a scoreboard of nothing to show a first-time
                  visitor, and it appears the moment a streak is real. */}
              {streak > 0 && (
                <div className="flex items-center" title="Daily streak">
                  {/* fire.gif is 40x40; scaled to 28px, then the outer box clips
                      ~3px (10%) off every side to tighten the flame. */}
                  <img
                    src="/img/fire.gif"
                    alt=""
                    className="w-[25px] h-[25px] max-w-none -mt-[3px] -ml-[3px]"
                  />
                  <span className="text-xl font-bold text-nlg-gold leading-none mx-[4px]">{streak}</span>
                  <span className="text-sm text-nlg-muted">day streak</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
